import { Dispatch } from "redux";
import axios from "axios";
import {SuperbetTrackingActionTypes, SuperbetTrackingAction} from "../../types/Superbet/superbetTrackingTypes";

interface ErrorResponse {
    code: number;
    message: string;
}

export const trackingSuperbet = (code: string): any => {
    return async (dispatch: Dispatch<SuperbetTrackingAction>) => {
        try {
            dispatch({ type: SuperbetTrackingActionTypes.FETCH_SUPERBET_TRACKING_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/tickets/${code}`,
                withCredentials: false
            });
            dispatch({ type: SuperbetTrackingActionTypes.FETCH_SUPERBET_TRACKING_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: SuperbetTrackingActionTypes.FETCH_SUPERBET_TRACKING_DATA_ERROR, payload: errorPayload });
        }
    }
}
